<script lang="ts">
  import Authorization from "@shared/svelte/Components/Authorization.svelte";
  import Icon from "@shared/svelte/Components/Icon.svelte";
  import UIRouterLink from "@shared/svelte/Components/UIRouterLink.svelte";
  import FizzStyles from "@shared/svelte/Components/FizzStyles.svelte";
  import { page } from "@roxi/routify";
  import LayoutStore from "@shared/svelte/Stores/LayoutStore";

  let backState: string = "settings";

  $: currentStateName = $page.path;

  $: if (currentStateName == "/settings/pricing/:distributorId") {
    backState = "layout.pricing";
  } else if (currentStateName == "/settings/employees/:userId") {
    backState = "layout.users";
  } else {
    backState = "layout.settings";
  }
</script>

<FizzStyles>
  <div class="fizz-surface">
    <div class="fizz-container fizz-flex-row fizz-inset-squish-16">
      <div class="fizz-flex-row fizz-full-width">
        <div class="grid-col c9-12 settings-breadcrumb">
          {#if $LayoutStore.isDesktop || currentStateName == "/settings/index"}
            <span class="default-subheader--bold">Account</span>
          {/if}
          {#if $LayoutStore.isMobile && currentStateName != "/settings/index"}
            <span class="fizz-flex-row-8">
              <UIRouterLink id={"arrow"} stateName={backState}>
                <Icon
                  extraClassNames={"color-brandPrimary cursor-pointer margin-right--smallest"}
                  type={"ArrowLeft"}
                />
              </UIRouterLink>
              {#if currentStateName == "/settings/profile"}
                Profile
              {:else if currentStateName == "/settings/notifications"}
                Notifications
              {:else if currentStateName == "/settings/locations"}
                Locations
              {:else if currentStateName == "/settings/accounts"}
                My Distributors
              {:else if currentStateName == "/settings/pricing/index"}
                Custom Pricing
              {:else if currentStateName == "/settings/pricing/:distributorId"}
                Custom Pricing Details
              {:else if currentStateName == "/settings/employees/index"}
                Employees
              {:else if currentStateName == "/settings/employees/:userId"}
                Employee Details
              {:else if currentStateName == "/settings/payment_methods"}
                Payment Methods
              {/if}
            </span>
          {/if}
        </div>
        {#if $LayoutStore.isDesktop || currentStateName == "/settings/index"}
          <div class="grid-col c3-12 align-right">
            <a
              class="fizz-text-brand fizz-no-wrap underline background-hover"
              target="_blank"
              rel="noopener noreferrer"
              href="https://support.provi.com"
            >
              Account Help
            </a>
          </div>
        {/if}
      </div>
    </div>
  </div>

  <div class="settings fizz-container padding--small">
    <div class="grid-row">
      {#if $LayoutStore.isDesktop}
        <!-- DESKTOP SETTINGS NAV -->
        <div
          class="background-white grid-col"
          class:c3-12={currentStateName != "/settings/index"}
          class:c12-12={currentStateName == "/settings/index"}
          data-testid="desktop-settings-nav"
        >
          <ul class="list list--vertical list--gutter-smaller padding--small">
            <li class="list-item cursor-pointer">
              <UIRouterLink stateName={"layout.profile"}>
                <Icon
                  extraClassNames={"display-inline margin-right--smallest fizz-text-brand"}
                  height={12}
                  opacity={currentStateName != "/settings/profile" ? 0.5 : 1}
                  type={"User"}
                  width={12}
                />
                <span
                  class="underline-hover fizz-text-brand"
                  class:w700={currentStateName == "/settings/profile"}
                  class:underline={currentStateName == "/settings/profile"}
                >
                  Profile
                </span>
              </UIRouterLink>
            </li>
            <li class="list-item cursor-pointer">
              <UIRouterLink stateName={"layout.notifications"}>
                <Icon
                  extraClassNames={"display-inline margin-right--smallest fizz-text-brand"}
                  height={12}
                  opacity={currentStateName != "/settings/notifications" ? 0.5 : 1}
                  type={"Notification"}
                  width={12}
                />
                <span
                  class="underline-hover fizz-text-brand"
                  class:w700={currentStateName == "/settings/notifications"}
                  class:underline={currentStateName == "/settings/notifications"}
                >
                  Notifications
                </span>
              </UIRouterLink>
            </li>
            <li class="cursor-pointer list-item">
              <UIRouterLink stateName={"layout.locations"}>
                <Icon
                  extraClassNames={"display-inline margin-right--smallest fizz-text-brand"}
                  height={12}
                  opacity={currentStateName != "/settings/locations" ? 0.5 : 1}
                  type={"Location"}
                  width={12}
                />
                <span
                  class="underline-hover fizz-text-brand"
                  class:w700={currentStateName == "/settings/locations"}
                  class:underline={currentStateName == "/settings/locations"}
                >
                  Locations
                </span>
              </UIRouterLink>
            </li>
            <li class="list-item cursor-pointer">
              <UIRouterLink stateName={"layout.accounts"}>
                <Icon
                  extraClassNames={"display-inline margin-right--smallest fizz-text-brand"}
                  height={12}
                  opacity={currentStateName != "/settings/accounts" ? 0.5 : 1}
                  type={"Truck"}
                  width={12}
                />
                <span
                  class="underline-hover fizz-text-brand"
                  class:w700={currentStateName == "/settings/accounts"}
                  class:underline={currentStateName == "/settings/accounts"}
                >
                  My Distributors
                </span>
              </UIRouterLink>
            </li>
            <Authorization authName="custom_prices.create">
              <li class="list-item cursor-pointer">
                <UIRouterLink stateName={"layout.pricing"}>
                  <Icon
                    extraClassNames={"display-inline margin-right--smallest fizz-text-brand"}
                    height={12}
                    opacity={currentStateName != "/settings/pricing" ? 0.5 : 1}
                    type={"Dollar"}
                    width={12}
                  />
                  <span
                    class="underline-hover fizz-text-brand"
                    class:w700={currentStateName == "/settings/pricing/index"}
                    class:underline={currentStateName == "/settings/pricing/index"}
                  >
                    Custom Pricing
                  </span>
                </UIRouterLink>
              </li>
            </Authorization>
            <Authorization authName="employees.index">
              <li class="list-item cursor-pointer">
                <UIRouterLink stateName={"layout.users"}>
                  <Icon
                    extraClassNames={"display-inline margin-right--smallest fizz-text-brand"}
                    height={12}
                    opacity={currentStateName != "/settings/employees" ? 0.5 : 1}
                    type={"Users"}
                    width={12}
                  />
                  <span
                    class="underline-hover fizz-text-brand"
                    class:w700={currentStateName == "/settings/employees/index"}
                    class:underline={currentStateName == "/settings/employees/index"}
                  >
                    Manage Employees
                  </span>
                </UIRouterLink>
              </li>
            </Authorization>
          </ul>
        </div>
        <!-- / DESKTOP SETTINGS NAV -->
      {/if}
      {#if $LayoutStore.isMobile && currentStateName == "/settings/index"}
        <!-- MOBILE Settings Nav -->
        <div
          class="grid-col c12-12 margin-right--small background-white"
          data-testid="mobile-settings-nav"
        >
          <ul class="list list--vertical list--gutter-none margin-top--small margin-bottom--small">
            <li class="list-item padding--smaller cursor-pointer">
              <UIRouterLink stateName={"layout.profile"}>
                <div class="media">
                  <div class="media-fluid fizz-text-brand">
                    <Icon
                      extraClassNames={"display-inline margin-right--smallest"}
                      height={12}
                      type={"User"}
                      width={12}
                    />
                    Profile
                  </div>
                  <Icon extraClassNames={"fizz-text-brand"} type={"ArrowRight"} />
                </div>
              </UIRouterLink>
            </li>
            <li class="list-item padding--smaller cursor-pointer">
              <UIRouterLink stateName={"layout.notifications"}>
                <div class="media">
                  <div class="media-fluid fizz-text-brand">
                    <Icon
                      extraClassNames={"display-inline margin-right--smallest"}
                      height={12}
                      type={"Notification"}
                      width={12}
                    />
                    Notifications
                  </div>
                  <Icon extraClassNames={"fizz-text-brand"} type={"ArrowRight"} />
                </div>
              </UIRouterLink>
            </li>
            <li class="list-item padding--smaller cursor-pointer">
              <UIRouterLink stateName={"layout.locations"}>
                <div class="media">
                  <div class="media-fluid fizz-text-brand">
                    <Icon
                      extraClassNames={"display-inline margin-right--smallest"}
                      height={12}
                      type={"Location"}
                      width={12}
                    />
                    Locations
                  </div>
                  <Icon
                    extraClassNames={"color-brandPrimary fizz-text-brand"}
                    type={"ArrowRight"}
                  />
                </div>
              </UIRouterLink>
            </li>
            <li class="list-item padding--smaller cursor-pointer">
              <UIRouterLink stateName={"layout.accounts"}>
                <div class="media">
                  <div class="media-fluid fizz-text-brand">
                    <Icon
                      extraClassNames={"display-inline margin-right--smallest"}
                      height={12}
                      type={"Truck"}
                      width={12}
                    />
                    My Distributors
                  </div>
                  <Icon
                    extraClassNames={"color-brandPrimary fizz-text-brand"}
                    type={"ArrowRight"}
                  />
                </div>
              </UIRouterLink>
            </li>
            <Authorization authName="custom_prices.create">
              <li class="list-item padding--smaller cursor-pointer">
                <UIRouterLink stateName={"layout.pricing"}>
                  <div class="media fizz-text-brand">
                    <div class="media-fluid fizz-text-brand">
                      <Icon
                        extraClassNames={"display-inline margin-right--smallest"}
                        height={12}
                        type={"Dollar"}
                        width={12}
                      />
                      <span class="vertical-align-top">Custom Pricing</span>
                    </div>
                    <Icon extraClassNames={"color-brandPrimary"} type={"ArrowRight"} />
                  </div>
                </UIRouterLink>
              </li>
            </Authorization>
            <Authorization authName="employees.index">
              <li class="list-item padding--smaller cursor-pointer">
                <UIRouterLink stateName={"layout.users"}>
                  <div class="media">
                    <div class="media-fluid fizz-text-brand">
                      <Icon
                        extraClassNames={"display-inline margin-right--smallest"}
                        height={12}
                        type={"Users"}
                        width={12}
                      />
                      Manage Employees
                    </div>
                    <Icon extraClassNames={"color-brandPrimary"} type={"ArrowRight"} />
                  </div>
                </UIRouterLink>
              </li>
            </Authorization>
          </ul>
        </div>
        <!-- MOBILE Settings Nav -->
      {/if}
      <div class="grid-col c12-12 c9-12--lg padding-left--small--lg">
        <div class="background-white">
          <slot />
        </div>
      </div>
    </div>
  </div>
</FizzStyles>
